module.exports = __webpack_public_path__ + "img/langTW.92c99b13.svg";